const RegexPattern = {
  Numbers: /^\d{10,11}$/,  
  Email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
};

export default RegexPattern;
